import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Menu.css";

import Tea from "../image/Tea.jpg";
import Coffee from "../image/Coffee.jpg";
import Milk from "../image/Milk.jpg";
import Boost from "../image/Boost.jpg";
import Samosa from "../image/Samosa.jpg";
import Sandwich from "../image/sandwichs.jpg";
import CoolDrink from "../image/Cool drink.jpg";

export default function Menu() {
    const { category } = useParams();
    const navigate = useNavigate();

    const menuItems = {
        Tea: [
            {
                id: 1,
                name: "Tea",
                price: 15,
                image: Tea
            },
            {
                id: 2,
                name: "Special Tea",
                price: 20,
                image: Tea
            }
        ],

        Coffee: [
            {
                id: 3,
                name: "Coffee",
                price: 20,
                image: Coffee
            },
            {
                id: 4,
                name: "Special Coffee",
                price: 30,
                image: Coffee
            }
        ],

        Milk: [
            {
                id: 5,
                name: "Milk",
                price: 20,
                image: Milk
            }
        ],

        Boost: [
            {
                id: 6,
                name: "Boost",
                price: 25,
                image: Boost
            }
        ],

        Snacks: [
            {
                id: 7,
                name: "Samosa",
                price: 10,
                image: Samosa
            },
            {
                id: 8,
                name: "Bajji",
                price: 15,
                image: Samosa
            }
        ],

        Sandwichs: [
            {
                id: 9,
                name: "Sandwich",
                price: 40,
                image: Sandwich
            }
        ],

        "Cool drink": [
            {
                id: 10,
                name: "Cool Drink",
                price: 30,
                image: CoolDrink
            }
        ]
    };

    const items = menuItems[category] || [];

    /* =========================
       ADD TO CART
    ========================= */

    const addToCart = (item) => {
        const oldCart = JSON.parse(
            localStorage.getItem("cart") || "[]"
        );

        const existingIndex = oldCart.findIndex(
            (cartItem) => cartItem.id === item.id
        );

        let updatedCart;

        if (existingIndex !== -1) {
            updatedCart = oldCart.map(
                (cartItem, index) => {
                    if (index === existingIndex) {
                        return {
                            ...cartItem,
                            qty:
                                Number(cartItem.qty || 1) + 1
                        };
                    }

                    return cartItem;
                }
            );
        } else {
            updatedCart = [
                ...oldCart,
                {
                    ...item,
                    qty: 1
                }
            ];
        }

        localStorage.setItem(
            "cart",
            JSON.stringify(updatedCart)
        );

        /* GO DIRECTLY TO CART */

        navigate("/cart");
    };

    /* =========================
       GO CART
    ========================= */

    const goToCart = () => {
        navigate("/cart");
    };

    return (
        <div className="menu-page">

            {/* HEADER */}

            <div className="menu-header">

                <button
                    type="button"
                    className="back-button"
                    onClick={() => navigate(-1)}
                >
                    ← Back
                </button>

                <h1>
                    {category}
                </h1>

                <button
                    type="button"
                    className="cart-top-button"
                    onClick={goToCart}
                >
                    🛒 Cart
                </button>

            </div>

            {/* PRODUCTS */}

            <div className="menu-container">

                {items.length === 0 ? (

                    <div className="no-products">
                        <h2>
                            No products found
                        </h2>

                        <button
                            type="button"
                            onClick={() =>
                                navigate("/product")
                            }
                        >
                            Back to Products
                        </button>
                    </div>

                ) : (

                    items.map((item) => (

                        <div
                            className="menu-card"
                            key={item.id}
                        >

                            <div className="menu-image-wrap">

                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="menu-product-image"
                                />

                            </div>

                            <div className="menu-product-info">

                                <span className="menu-category">
                                    {category}
                                </span>

                                <h2>
                                    {item.name}
                                </h2>

                                <h3>
                                    ₹{item.price}
                                </h3>

                                <button
                                    type="button"
                                    className="add-cart-button"
                                    onClick={() =>
                                        addToCart(item)
                                    }
                                >
                                    <span>
                                        🛒 Add to Cart
                                    </span>

                                    <span>
                                        →
                                    </span>
                                </button>

                            </div>

                        </div>

                    ))

                )}

            </div>

            {/* BOTTOM CART */}

            <div className="cart-bottom">

                <button
                    type="button"
                    onClick={goToCart}
                >
                    🛒 Go to Cart
                </button>

            </div>

        </div>
    );
}